import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { landingRoute } from '@/shell/navigation';

/**
 * Where a role lands after signing in. Derived from the nav, so a permission
 * change moves the landing route with it — acceptance criterion C-09 asserts
 * ten sign-ins and ten correct landing routes.
 */
export function LandingRedirect() {
  const { has, status } = useAuth();
  if (status === 'loading') return null;
  // With no session there is nowhere to land: the first screen is the
  // sign-in screen, not a route the visitor cannot open.
  if (status !== 'signed-in') return <Navigate to="/login" replace />;
  return <Navigate to={landingRoute(has)} replace />;
}
